import { jsx } from "react/jsx-runtime";
import { Button } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { COMPONENT_NAME } from "./constants.js";
import { OrdersAndReturnsLinkText } from "./styles.js";
function OrdersAndReturnsLink({
  entry
}) {
  if (!entry) return null;
  return (
    // using a `<Button>` in place of `<Link>` so we can specify the `target` attribute
    /* @__PURE__ */ jsx(
      Analytics,
      {
        analyticData: {
          component: {
            trackedData: [
              entry.active_state.active_state_link.title
            ]
          }
        },
        children: /* @__PURE__ */ jsx(
          Button,
          {
            "aria-label": entry.active_state.active_state_link.title,
            "data-testid": COMPONENT_NAME,
            href: entry.active_state.active_state_link.href,
            target: entry.target,
            uniqueId: "OrdersAndReturns",
            variant: "text-button",
            children: /* @__PURE__ */ jsx(
              OrdersAndReturnsLinkText,
              {
                "aria-hidden": true,
                uniqueId: "OrdersAndReturns",
                children: entry.active_state.active_state_link.title
              }
            )
          }
        )
      }
    )
  );
}
export {
  OrdersAndReturnsLink
};
